export default __webpack_public_path__ + "static/defilytica_simple_alt-a65342bc35265ff192f062031b74cc9f.png";